export const decodeXsAndOsTeamName = (value: number): string => {
  const chars: string[] = []
  for (let n = value; n > 0; n >>= 5) {
    chars.push(String.fromCharCode('A'.charCodeAt(0) + ((n & 0x1f) - 1)))
  }
  return chars.reverse().join('')
}
